// extracted by mini-css-extract-plugin
module.exports = {"root":"AssetPreview_root__8_my3"};